import type { CeuGoal } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWR from "swr";

const useCeuGoals = () => {
	const { userId } = useAuth();
	const {
		data: ceuGoals,
		isLoading,
		mutate,
	} = useSWR<CeuGoal[]>(userId ? "/users/ceu-goals" : null);

	return { ceuGoals, isLoadingCeuGoals: isLoading, mutateCeuGoals: mutate };
};

export default useCeuGoals;
